import React from 'react';
import { Dialog } from 'primereact/dialog';

export const MailDialog = ({ visible, onCancel }) => {
    return (
        <Dialog 
            header="Enviar Mail" 
            visible={visible} 
            style={{ width: '50vw' }} 
            onHide={onCancel}
        >
            <p className="m-0">
                Contenido del Mail Dialog
            </p>
        </Dialog>
    );
};